import React, { Component } from 'react';

export default class ImageRugs extends Component {

    render() {
        return (
            <img className="image-preview" src={this.props.image} alt="rug-img" />
        )
    }
}